export const DESCRIPTOR_TYPE_PROP = 'py/object';
export const DESCRIPTOR_PY_SEC = 'py/seq';
export var DescriptorType;
(function (DescriptorType) {
    DescriptorType["complex"] = "iptim.amf.ComplexDescriptor";
    DescriptorType["date"] = "iptim.amf.SimpleDateDescriptor";
    DescriptorType["category"] = "iptim.amf.CategoryDescriptor";
    DescriptorType["numeric"] = "iptim.amf.NumericDescriptor";
    DescriptorType["text"] = "iptim.amf.TextDescriptor";
    DescriptorType["geo"] = "iptim.amf.GeoDescriptor";
    DescriptorType["dynamicCategory"] = "iptim.amf.DynamicCategoryDescriptor";
    DescriptorType["enumeration"] = "iptim.amf.Enumeration";
    DescriptorType["pyAmfArrayCol"] = "pyamf.flex.ArrayCollection";
})(DescriptorType || (DescriptorType = {}));
